import {
  LANG_EN,
  LANG_FR_FR,
  LANG_FR_BE,
  LANG_NL_BE,
  LANG_DE_DE,
  LANG_FR_CA,
} from "./constants";

export const t = (locale, key) =>
  translations[locale]?.[key] || translations[LANG_EN]?.[key] || key;

export const translator = locale => key => t(locale, key);

export const Trans = ({ locale, key }) => t(locale, key);

const translations = {
  [LANG_EN]: {
    "seo.title": "eConsult Platform",
    "seo.description": "Omnidoc is an eConsult Platform",
    "navigation.open-menu": "Open menu",
    "navigation.close-menu": "Close menu",
    "navigation.news": "News",
    "navigation.request-a-demo": "Request a demo",
    "navigation.log-in": "Log\xa0in",
    "navigation.want-to-try-our-solutions": "Want to try our solutions?",
    "navigation.terms": "Terms of Service",
    "navigation.personal-data": "Personal Data",
    "navigation.about":
      "Omnidoc is an independent company created in 2019 and entirely dedicated to the development of its teleexpertise solution and its adoption by healthcare professionals.",
    "navigation.confidentiality": "Confidentiality",
    "nvaigtation.contact-us": "Contact us",
    "navigation.solutions": "Solutions",
    "navigation.more-about-omnidoc": "More about Omnidoc",
    "news.title": "News",
    "news.seo-title": "News",
    "press.title": "Press",
    "press.download-kit": "Download our press kit",
    "press.kit": "Press kit",
    "press.category-press": "In the press",
    "press.category-communique": "Press release",
    "info.title": "Information",
    "info.seo-title": "Information",
    "contact-form.title": "Request a personalized demo",
    "contact-form.form-description":
      "Our team is at your disposal to present the solution and discuss its implementation in your context.",
    "contact-form.first-name": "First name",
    "contact-form.last-name": "Last name",
    "contact-form.email": "Email",
    "contact-form.phone": "Phone",
    "contact-form.organization": "Organization",
    "contact-form.role": "Position",
    "contact-form.description": "Project",
    "contact-form.submit-text": "Get more information",
    "contact-form-thanks.title": "Noted!",
    "contact-form-thanks.formSubmitConfirm":
      "We have succesfully received your request for a demo.",
    "contact-form-thanks.backToHome": "Back to homepage",
    "footer.all-rights": "Omnidoc, all rights reserved.",
    "iframe-element.download": "Download",
  },
  [LANG_FR_FR]: {
    "seo.title":
      "Solution de collaboration médicale - Téléexpertise, RCP & téléconsultation",
    "seo.description":
      "Omnidoc connecte les professionnels et organisations médicales afin de faciliter chaque étape du parcours de soins : téléexpertise, adressage, réunion de concertation ou téléconsultation.",
    "navigation.open-menu": "Ouvrir le menu",
    "navigation.close-menu": "Fermer le menu",
    "navigation.news": "Actualités",
    "navigation.request-a-demo": "Demander une démo",
    "navigation.log-in": "Se\xa0connecter",
    "navigation.want-to-try-our-solutions":
      "Vous souhaitez découvrir nos solutions ?",
    "navigation.terms": "CGU",
    "navigation.personal-data": "Données personnelles",
    "navigation.about":
      "Omnidoc est une société indépendante créée en 2019 et entièrement dédiée au développement de sa solution de collaboration médicale et à sa prise en main par les professionnels de santé.",
    "navigation.confidentiality": "Confidentialité",
    "nvaigtation.contact-us": "Nous contacter",
    "navigation.solutions": "Solutions",
    "navigation.more-about-omnidoc": "Plus sur Omnidoc",
    "news.title": "Actualités",
    "news.seo-title": "Actualités - Téléexpertise",
    "press.title": "Presse",
    "press.download-kit": "Télécharger notre dossier de presse",
    "press.kit": "Kit presse",
    "press.category-press": "Dans la presse",
    "press.category-communique": "Communiqué",
    "info.title": "Informations",
    "info.seo-title": "Toutes les informations - Téléexpertise",
    "contact-form.title": "Demander une démonstration personnalisée",
    "contact-form.form-description":
      "Notre équipe est à votre disposition pour vous présenter la solution et discuter de sa mise en place dans votre contexte.",
    "contact-form.first-name": "Prénom",
    "contact-form.last-name": "Nom",
    "contact-form.email": "Email",
    "contact-form.phone": "Numéro de téléphone",
    "contact-form.organization": "Organisation",
    "contact-form.role": "Fonction",
    "contact-form.description": "Projet",
    "contact-form.submit-text": "Obtenir plus d’informations",
    "contact-form-thanks.title": "C'est noté !",
    "contact-form-thanks.formSubmitConfirm":
      "Nous avons bien reçu votre demande de démo.",
    "contact-form-thanks.backToHome": "Retourner à l'accueil",
    "footer.all-rights": "Omnidoc, tous droits réservés.",
    "iframe-element.download": "Télécharger",
  },
  [LANG_DE_DE]: {
    "seo.title": "Omnidoc, Telekonsil Plattform",
    "seo.description":
      "Omnidoc ist eine Telekonsil Plattform für Gesundheitsfachkräfte und medizinische Einrichtungen, die den Austausch über den Befund eines Patientenfalls verbessern, sichern und effizienter gestalten möchte.",
    "navigation.open-menu": "Menü öffnen",
    "navigation.close-menu": "Menü schließen",
    "navigation.news": "Aktuelles",
    "navigation.request-a-demo": "Demo buchen",
    "navigation.log-in": "Anmelden",
    "navigation.want-to-try-our-solutions":
      "Möchten Sie unsere Lösungen erkunden?",
    "navigation.terms": "Nutzungsbedingungen",
    "navigation.personal-data": "Datenschutz",
    "navigation.about":
      "Omnidoc ist ein unabhängiges Unternehmen, das 2019 gegründet wurde und sich ausschließlich der Entwicklung seiner Plattform für den Austausch zwischen Gesundheitsfachkräften widmet.",
    "navigation.confidentiality": "Vertraulichkeit",
    "nvaigtation.contact-us": "Kontaktieren Sie uns",
    "navigation.solutions": "Lösungen",
    "navigation.more-about-omnidoc": "Mehr über Omnidoc",
    "news.title": "Aktuelles",
    "news.seo-title": "Aktuelles",
    "press.download-kit": "Unser Pressemappe herunterladen",
    "press.kit": "Pressekit",
    "press.category-press": "In der Presse",
    "press.category-communique": "Pressemitteilung",
    "info.title": "Informationen",
    "info.seo-title": "Alle Informationen - Telekonsile",
    "press.title": "Presse",
    "contact-form.title": "Eine persönliche Beratung anfragen",
    "contact-form.form-description":
      "Unser Team steht Ihnen gerne zur Verfügung, um Ihnen Omnidoc vorzustellen und die Umsetzung in Ihrem Kontext zu besprechen.",
    "contact-form.first-name": "Vorname",
    "contact-form.last-name": "Nachname",
    "contact-form.email": "E-Mail",
    "contact-form.phone": "Telefonnummer",
    "contact-form.organization": "Organisation",
    "contact-form.role": "Funktion",
    "contact-form.description": "Projekt",
    "contact-form.submit-text": "Informationen erhalten",
    "contact-form-thanks.title": "Vielen Dank!",
    "contact-form-thanks.formSubmitConfirm":
      "Wir haben Ihre Anfrage erhalten und melden uns in kürze.",
    "contact-form-thanks.backToHome": "Zurück zur Homepage",
    "footer.all-rights": "Omnidoc, alle Rechte vorbehalte.",
    "iframe-element.download": "Herunterladen",
  },
  [LANG_NL_BE]: {
    "seo.title": "Oplossing voor tele-expertise en e-MDO",
    "seo.description":
      "Omnidoc is een oplossing voor tele-expertise en e-MDO voor zorgverleners en medische organisaties die de uitgewisselde adviezen willen verbeteren, beveiligen en valoriseren.",
    "navigation.open-menu": "Menu openen",
    "navigation.close-menu": "Menu sluiten",
    "navigation.news": "Nieuws",
    "navigation.request-a-demo": "Vraag een demo aan",
    "navigation.log-in": "Inloggen",
    "navigation.want-to-try-our-solutions":
      "Wilt u onze oplossingen ontdekken?",
    "navigation.terms": "Gebruiksvoorwaarden",
    "navigation.personal-data": "Persoonsgegevens",
    "navigation.about":
      "Omnidoc is een onafhankelijk bedrijf opgericht in 2019 en volledig gewijd aan de ontwikkeling van zijn tele-expertise-oplossing en de overname ervan door zorgverleners.",
    "navigation.confidentiality": "Vertrouwelijkheid",
    "nvaigtation.contact-us": "Neem contact met ons op",
    "navigation.solutions": "Oplossingen",
    "navigation.more-about-omnidoc": "Meer over Omnidoc",
    "news.title": "Nieuws",
    "news.seo-title": "Nieuws - Tele-expertise",
    "press.title": "Pers",
    "press.download-kit": "Download onze persmap",
    "press.kit": "Perskit",
    "press.category-press": "In de pers",
    "press.category-communique": "Persbericht",
    "info.title": "Informatie",
    "info.seo-title": "Alle informatie - Tele-expertise",
    "contact-form.title": "Vraag een gepersonaliseerde demonstratie",
    "contact-form.form-description":
      "Ons team staat tot uw beschikking om u de oplossing te presenteren en te bespreken hoe deze in uw context kan worden geïmplementeerd.",
    "contact-form.first-name": "Voornaam",
    "contact-form.last-name": "Achternaam",
    "contact-form.email": "E-mail",
    "contact-form.phone": "Telefoonnummer",
    "contact-form.organization": "Organisatie",
    "contact-form.role": "Functie",
    "contact-form.description": "Project",
    "contact-form.submit-text": "Meer informatie",
    "contact-form-thanks.title": "Is genoteerd!",
    "contact-form-thanks.formSubmitConfirm":
      "We hebben uw demo-aanvraag goed ontvangen.",
    "contact-form-thanks.backToHome": "Terug naar het begin",
    "footer.all-rights": "Omnidoc alle rechten voorbehouden.",
    "iframe-element.download": "Downloaden",
  },
};

translations[LANG_FR_BE] = translations[LANG_FR_FR];
translations[LANG_FR_CA] = translations[LANG_FR_FR];
